import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import {
  CategoryButtonTitle,
  TLongTermOptionValue,
  TViewSwitcherKey,
} from '@models/home';
import CategoryTogglingButtonList from '@pages/Home/components/CategoryTogglingButtonList/CategoryTogglingButtonList';
import InfoCardList from '@pages/Home/components/InfoCardList/InfoCardList';
// import TreeGraph from '@pages/Home/components/TreeGraph/TreeGraph';
import ViewSwitcher from '@pages/Home/components/ViewSwitcher/ViewSwitcher';
import ChargingEquipmentStability from '@pages/Home/layouts/ChargingEquipmentStability/ChargingEquipmentStability';
import EnergyDispatchSecurity from '@pages/Home/layouts/EnergyDispatchSecurity/EnergyDispatchSecurity';
import FinancialProfitabilityEfficiency from '@pages/Home/layouts/FinancialProfitabilityEfficiency/FinancialProfitabilityEfficiency';
import { AppDispatch } from '@store/index';
import {
  setCategory,
  setView,
} from '@store/reducers/dashboardBackgroundImgSlice';

import './Home.scss';

// export interface Node {
//   id: number;
//   name: string;
//   x: number;
//   y: number;
// }

// export const NODES: { [key: string]: Node } = {
//   PLATFORM: {
//     id: 1,
//     name: '平台',
//     x: 350,
//     y: 170,
//   },
//   POWER_GRID: {
//     id: 2,
//     name: '電網',
//     x: 800,
//     y: 90,
//   },
//   STATION: {
//     id: 3,
//     name: '充電站',
//     x: 1000,
//     y: 620,
//   },
//   DISTRIBUTOR: {
//     id: 4,
//     name: '分電盤',
//     x: 500,
//     y: 260,
//   },
//   PILE: {
//     id: 5,
//     name: '充電樁/槍',
//     x: 550,
//     y: 490,
//   },
//   EV: {
//     id: 6,
//     name: '電動車',
//     x: 200,
//     y: 590,
//   },
//   MEMBER: {
//     id: 7,
//     name: '會員',
//     x: 400,
//     y: 750,
//   },
// };

// export interface ILink {
//   data: [Node, Node];
//   direction: 'left' | 'right' | 'both';
//   color: string | string[];
// }

function layoutSwitcher(
  activeCategory: CategoryButtonTitle,
  activeTab: TViewSwitcherKey,
  activeLongTermOption: TLongTermOptionValue,
) {
  switch (activeCategory) {
    case 'Home.EnergyDispatchSecurity':
      return (
        <EnergyDispatchSecurity
          activeTab={activeTab}
          activeLongTermOption={activeLongTermOption}
        />
      );
    case 'Home.ChargingEquipmentStability':
      return (
        <ChargingEquipmentStability
          activeTab={activeTab}
          activeLongTermOption={activeLongTermOption}
        />
      );
    case 'Home.FinancialProfitabilityEfficiency':
      return (
        <FinancialProfitabilityEfficiency
          activeTab={activeTab}
          activeLongTermOption={activeLongTermOption}
        />
      );
    default:
      return <div>default</div>;
  }
}

function Home() {
  const [activeCategory, setActiveCategory] =
    useState<CategoryButtonTitle | null>(null);
  const [activeTab, setActiveTab] = useState<TViewSwitcherKey>('immediate');
  const [activeLongTermOption, setActiveLongTermOption] =
    useState<TLongTermOptionValue>('MONTH');
  const [displaySectionClass, setDisplaySectionClass] = useState<string>(
    'display-section display-section--fade-in',
  );
  const [isContentVisible, setIsContentVisible] = useState(false);
  const dispatch = useDispatch<AppDispatch>();

  function activeCategoryHandler(title: CategoryButtonTitle) {
    if (isContentVisible) setIsContentVisible(false);
    setActiveCategory(title);
  }

  function activeTabHandler(tab: TViewSwitcherKey) {
    if (isContentVisible) setIsContentVisible(false);
    setActiveTab(tab);
  }

  useEffect(() => {
    setDisplaySectionClass('display-section');
    requestAnimationFrame(() => {
      setDisplaySectionClass(
        (prevDisplaySectionClass) =>
          `${prevDisplaySectionClass} display-section--fade-in`,
      );

      setTimeout(() => {
        dispatch(setCategory(activeCategory));
        dispatch(setView(activeTab));
        setIsContentVisible(true);
      }, 1000); // 與動畫時間一致
    });
  }, [activeCategory, activeTab]);

  return (
    <div className="Home">
      <InfoCardList currentCategory={activeCategory} />
      <CategoryTogglingButtonList
        setActiveCategory={(title) =>
          activeCategoryHandler(title as CategoryButtonTitle)
        }
      />
      <section className="Home__data-section">
        {activeCategory && (
          <ViewSwitcher
            onLongTermOptionChange={(value) => setActiveLongTermOption(value)}
            onViewSwitch={(tab) => activeTabHandler(tab as TViewSwitcherKey)}
          />
        )}
        {/* {activeCategory && <TreeGraph category={activeCategory} />} */}
        <section className={displaySectionClass}>
          {isContentVisible &&
            activeCategory &&
            layoutSwitcher(activeCategory, activeTab, activeLongTermOption)}
        </section>
      </section>
    </div>
  );
}

export default Home;
